export const GTM = {
  gtmId: process.env.NEXT_PUBLIC_GTM_ID || '',
};
